import APIClient from '@/shared/http/clients/api'

const resourceName = 'contratos-vigentes'
const APICore = process.env.APIBaseURLCore

const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/`, document)
const SearchByModalidadeProduto = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/modalidades-produtos/?document=${document}&page=${index}&size=${limit}`, config)
const SearchBySubmodalidadeBacen = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/submodalidades-bacen/?document=${document}&page=${index}&size=${limit}`, config)
const SearchByModalidadeBacen = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/modalidades-bacen/?document=${document}&page=${index}&size=${limit}`, config)
const GetModalidadeProduto = (data, config = {}) => APIClient.get(`${APICore}/${resourceName}/modalidades-produtos/?size=500`, config, data)
const GetSubmodalidadeBacen = (data, config = {}) => APIClient.get(`${APICore}/${resourceName}/submodalidades-bacen/?size=500`, config, data)

/**
 * @name ContratosVigentesRepository
 * @description Captação Remunerada Diária
 * @type { Respository }
 */
const ContratosVigentesRepository = {
  Search,
  SearchByModalidadeProduto,
  SearchBySubmodalidadeBacen,
  SearchByModalidadeBacen,
  GetModalidadeProduto,
  GetSubmodalidadeBacen
}

export default ContratosVigentesRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/contratosvigentes.js